module.exports = "<input type=\"radio\"\n       [id]=\"name + '_' + value\"\n       [name]=\"name\"\n       [value]=\"value\"\n       [disabled]=\"disabled\"\n       [(ngModel)]=\"innerValue\">\n\n<label [for]=\"name + '_' + value\">\n    <span></span>\n    {{ altValue ? altValue : value | translate }}\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-radio/ui-radio.html
// module id = 1075
// module chunks = 3